
import { Component, Mixins, Prop } from "vue-property-decorator"
import Common from '../mixins/common';
import { getDoc } from "firebase/firestore";
import { SchedulingSheet } from "@/common-datatypes";
import ModalAlert from "@/components/ModalAlert.vue"
import ModalSchedulingTable from "@/components/ModalSchedulingTable.vue"

@Component({
  components: {
    ModalAlert,
    ModalSchedulingTable
  }
})

export default class SchedulingObject extends Mixins(Common) {
  @Prop({type: String, default: ''}) private schedulingSheetId?: string
  @Prop({type: String, default: ''}) private entryUser?: string

  isLoading: (boolean | string) = false

  //observers: (Unsubscribe | undefined)[] = []

  modalSchedulingProps = {
    title: '',
    schedulingSheetId: '',
    entryUser: '',
    isShow: false
  }

  modalAlertProps = {
    title: '',
    message: '',
    isShow: false
  }


  async created(){
    try{
      this.isLoading = true
      this.$store.commit("setLoading",true)

      if(this.schedulingSheetId && this.entryUser){
        const schedulingDoc = await getDoc(this.$getSchedulingSheetDocRef(this.schedulingSheetId))

        if(schedulingDoc.exists()){
          const sheet = schedulingDoc.data() as SchedulingSheet
          if(sheet){
            this.modalSchedulingProps = {
              ...this.modalSchedulingProps,
              schedulingSheetId: this.schedulingSheetId,
              entryUser: this.entryUser,
              title: sheet.title,
              isShow: true
            }
          }
        }else{
          this.showAlertNotFound()
        }
      }else{
        this.showAlertNotFound()
      }
    }catch(error){
      this.showAlertNotAuthorized()
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  showAlertNotAuthorized(){
    this.modalAlertProps = {
      title: this.$t('message.notAuthorized') as string,
      message: this.$t('scheduling.notAuthorized') as string,
      isShow: true
    }
  }

  showAlertNotFound(){
    this.modalAlertProps = {
      title: this.$t('message.notFound') as string,
      message: this.$t('scheduling.notFound') as string,
      isShow: true
    }
  }

   onClose() {
    this.modalAlertProps.isShow = false
    this.modalSchedulingProps.isShow = false
    this.$emit("onClose", true)
  }

  destroyed() {
    //this.$unsubscriber(this.observers)
  }
}
